import Api from './GenericOrderApi';
import * as types from './GenericOrderTypes';

export function newGenericOrderSuccess(model) {
    return { type: types.NEW_GENERIC_ORDER_SUCCESS, result: model };
}

export function newGenericOrder(orderCollectionId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.newGenericOrder(orderCollectionId).then((result: any) => {
            dispatch(newGenericOrderSuccess(result));
        });
}

export function createGenericOrder(genericOrder) {
    return Api.createGenericOrder(genericOrder);
}
